(() => {
  const unproject = (x, y) => {
    const a = 202.050694, b = 0.122293159, c = -0.0805673422, d = -327.454742;
    const X = x + 491.389669, Y = y - 17613.5654, determinant = a * d - b * c;
    return [(d * X - b * Y) / determinant, (-c * X + a * Y) / determinant];
  };
  const regions = {
    'België': [29.1, 750, 810.3, 1386.9], 'Drenthe': [751.5, 185.3, 948.1, 383.7],
    'Flevoland': [550.5, 307.6, 724, 502.6], 'Fryslân': [495.8, 79.4, 813.7, 320.6],
    'Gelderland': [525.3, 414.6, 894.7, 672.9], 'Groningen': [762.8, 66.8, 973.3, 308.3],
    'Limburg': [639.6, 658.6, 772.9, 990.2], 'Noord-Brabant': [362, 641.6, 735.4, 839.3],
    'Noord-Holland': [423, 192.4, 588.7, 531.3], 'Overijssel': [685.9, 302.9, 943.8, 547.1],
    'Utrecht': [483.2, 486.4, 651.9, 632.4], 'Zeeland': [193.5, 665.1, 379.2, 846.1],
    'Zuid-Holland': [290.7, 477.9, 530.7, 698.7],
  };
  const statusLabels = {
    pending: 'Locatie nog niet bevestigd', confirmed: 'Ophaalplanning volgt',
    scheduled: 'Ophalen gepland', sold_out: 'Uitverkocht',
    paused: 'Dit seizoen geen pick-up', former: 'Geen pick-up meer',
  };
  const normalise = (value) => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const address = (...parts) => parts.map((part) => String(part || '').trim().replace(/,\s*$/, '')).filter(Boolean).join(', ');
  const readHash = (hash) => {
    try { return decodeURIComponent(String(hash || '').replace(/^#/, '')); }
    catch (_error) { return ''; }
  };
  const keyboardOffset = (layoutHeight, visualViewport) => visualViewport
    ? Math.max(0, layoutHeight - visualViewport.height - visualViewport.offsetTop) : 0;
  const matchesLocation = (query, row, location) => !query || normalise([
    row.dataset.title, row.dataset.city, location?.company_name, location?.city, location?.postal_code,
  ].filter(Boolean).join(' ')).includes(normalise(query.trim()));
  window.BbMapCore = { readHash, matchesLocation, unproject, keyboardOffset };
  const readProduct = (value) => {
    const parts = String(value || '').split(':').map(Number);
    return parts.length === 2 && parts.every((part) => Number.isSafeInteger(part) && part > 0)
      ? { product_id: parts[0], variant_id: parts[1], quantity: 1 } : null;
  };
  const dateLabel = (date) => new Intl.DateTimeFormat('nl-NL', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC',
  }).format(new Date(`${date}T12:00:00Z`));
  const monthLabel = (date) => new Intl.DateTimeFormat('nl-NL', {
    month: 'long', year: 'numeric', timeZone: 'UTC',
  }).format(new Date(`${date}T12:00:00Z`));
  async function runPool(items, limit, worker) {
    let next = 0;
    await Promise.all(Array.from({ length: Math.min(limit, items.length) }, async () => {
      while (next < items.length) await worker(items[next++]);
    }));
  }

  function init(section) {
    if (section.dataset.bbMapReady === 'true') return;
    section.dataset.bbMapReady = 'true';
    const $ = (selector) => section.querySelector(selector);
    const rows = [...section.querySelectorAll('[data-bb-map-location]')];
    const cities = [...section.querySelectorAll('[data-bb-map-city]')];
    const search = $('[data-bb-map-search]');
    const initialCity = new URLSearchParams(window.location.search).get('stad');
    if (initialCity && search) search.value = initialCity;
    const count = $('[data-bb-map-count]');
    const empty = $('[data-bb-map-empty]');
    const message = $('[data-bb-map-message]');
    const viewport = $('[data-bb-map-viewport]');
    const plane = $('[data-bb-map-plane]');
    const tiles = $('[data-bb-map-tiles]');
    const popup = $('[data-bb-map-popup]');
    const detail = $('[data-bb-map-detail]');
    const close = $('[data-bb-map-close]');
    const results = $('.bb-map__results');
    const records = new Map();
    const scheduleCache = new Map();
    let loading = true;
    let selected = null;
    let popupRow = null;
    let popupKind = null;
    let selectedRegion = '';
    let returnFocus = null;
    let scheduleRequest = 0;
    let popupRequest = 0;
    const markers = new Map();
    let map = null;
    let mapLoaded = false;
    let motionFrame = 0;
    let motion = null;
    let ownsHistory = false;
    let closeTimer = null;
    const mobileLayout = window.matchMedia('(max-width: 749px)');
    const desktopLayout = window.matchMedia('(min-width: 1024px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    function updateHeaderOffset() {
      const header = document.querySelector('.bb-site-header');
      const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      section.style.setProperty('--bb-map-header-offset', `${Math.max(0, Math.round(headerBottom))}px`);
    }
    updateHeaderOffset();
    window.addEventListener('resize', updateHeaderOffset);
    if (window.ResizeObserver) {
      const header = document.querySelector('.bb-site-header');
      if (header) new ResizeObserver(updateHeaderOffset).observe(header);
    }
    const resetDesktopScroll = () => {
      if (desktopLayout.matches) window.scrollTo({ top: 0, behavior: 'instant' });
    };
    if (desktopLayout.matches && 'scrollRestoration' in window.history) window.history.scrollRestoration = 'manual';
    resetDesktopScroll();
    window.addEventListener('load', resetDesktopScroll);
    window.addEventListener('pageshow', resetDesktopScroll);
    results.addEventListener('wheel', (event) => {
      if (desktopLayout.matches && !event.ctrlKey && event.target.closest('.bb-map__sidebar-head')) {
        $('[data-bb-map-list-scroll]').scrollBy({ top: event.deltaY });
        event.preventDefault();
      }
    }, { passive: false });
    if (window.IntersectionObserver) new IntersectionObserver(([entry]) => {
      section.classList.toggle('bb-map--out-of-view', !entry.isIntersecting);
      updateMotionActivity();
    }).observe(section);
    document.addEventListener('visibilitychange', updateMotionActivity);
    reducedMotion.addEventListener('change', updateMotionActivity);
    function updateMobileSearch() {
      const visualViewport = window.visualViewport;
      const keyboardOffset = visualViewport && mobileLayout.matches && document.activeElement === search
        ? window.BbMapCore.keyboardOffset(window.innerHeight, visualViewport) : 0;
      section.style.setProperty('--bb-map-keyboard-offset', `${Math.round(keyboardOffset)}px`);
    }
    function endSearch() {
      section.classList.remove('bb-map--search-active');
      updateMobileSearch();
      window.requestAnimationFrame(() => map?.resize());
    }
    search.addEventListener('focus', () => {
      section.classList.add('bb-map--search-active');
      updateMobileSearch();
      window.requestAnimationFrame(() => map?.resize());
    });
    search.addEventListener('blur', endSearch);
    search.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') search.blur();
    });
    window.visualViewport?.addEventListener('resize', updateMobileSearch);
    window.visualViewport?.addEventListener('scroll', updateMobileSearch);
    mobileLayout.addEventListener('change', updateMobileSearch);

    function zoomToPoint(longitude, latitude, nextZoom = 10) {
      map?.flyTo({ center: [longitude, latitude], zoom: Math.max(map.getZoom(), nextZoom), essential: true });
    }
    function zoomToRows(groupRows) {
      if (!map || !groupRows.length) return;
      if (groupRows.length === 1) return zoomToPoint(groupRows[0].bbMapLng, groupRows[0].bbMapLat, 10);
      const bounds = new window.maplibregl.LngLatBounds();
      groupRows.forEach((row) => bounds.extend([row.bbMapLng, row.bbMapLat]));
      map.fitBounds(bounds, { padding: Math.min(64, viewport.clientWidth * .12), maxZoom: 11, duration: 500 });
    }
    function showWholeMap() {
      selectedRegion = '';
      zoomToRows(visibleRows());
      hidePopup();
    }
    function zoomToRegion(name) {
      const bounds = regions[name];
      if (!bounds) return showWholeMap();
      selectedRegion = name;
      const [x1, y1, x2, y2] = bounds;
      const southwest = unproject(x1, y2), northeast = unproject(x2, y1);
      map?.fitBounds([southwest, northeast], { padding: 30, duration: 500 });
      hidePopup();
    }
    function visibleRows() { return rows.filter((row) => !row.hidden && Number.isFinite(row.bbMapLng)); }
    function addVehicle(type, imageUrl, coordinate) {
      const element = document.createElement(type === 'car' ? 'button' : 'div');
      element.className = `bb-map__vehicle bb-map__vehicle--${type}`;
      if (type === 'car') {
        element.type = 'button';
        element.setAttribute('aria-label', 'Bekijk thuisbezorgen');
        element.setAttribute('aria-controls', popup.id);
        element.setAttribute('aria-expanded', 'false');
        element.addEventListener('click', (event) => { event.stopPropagation(); showDeliveryPopup(); });
      } else element.setAttribute('aria-hidden', 'true');
      const image = document.createElement('img');
      image.src = imageUrl;
      image.alt = '';
      element.append(image);
      const marker = new window.maplibregl.Marker({ element, anchor: 'center' })
        .setLngLat([coordinate.lng, coordinate.lat]).addTo(map);
      return { element, image, marker };
    }
    function animateMotion(now) {
      motionFrame = 0;
      if (!motion || !section.isConnected || motion.pausedAt) return;
      const bikeView = map.getZoom() >= 10.5;
      const bikeVisible = bikeView && motion.bike
        && map.getBounds().contains([motion.vondeltuin.lng, motion.vondeltuin.lat]);
      motion.car.element.hidden = bikeView;
      if (motion.bike) motion.bike.element.hidden = !bikeVisible;
      if (!bikeView) {
        const pose = window.BbMapMotion.carPose(motion.route, now - motion.started);
        motion.car.marker.setLngLat([pose.lng, pose.lat]);
        motion.car.image.style.transform = `rotate(${pose.heading}deg)`;
      } else if (bikeVisible) {
        const pose = window.BbMapMotion.bikePose(motion.vondeltuin, now - motion.started);
        motion.bike.marker.setLngLat([pose.lng, pose.lat]);
      }
      motionFrame = window.requestAnimationFrame(animateMotion);
    }
    function setMotionPaused(reason, paused) {
      if (!motion) return;
      const wasPaused = motion.pauseReasons.size > 0;
      if (paused) motion.pauseReasons.add(reason);
      else motion.pauseReasons.delete(reason);
      const isPaused = motion.pauseReasons.size > 0;
      if (!wasPaused && isPaused) motion.pausedAt = performance.now();
      if (wasPaused && !isPaused) {
        motion.started += performance.now() - motion.pausedAt;
        motion.pausedAt = 0;
      }
    }
    function updateMotionActivity() {
      if (!motion) return;
      const visible = !document.hidden && !section.classList.contains('bb-map--out-of-view');
      setMotionPaused('invisible', !visible);
      setMotionPaused('reduced', reducedMotion.matches);
      const moving = visible && !motion.pausedAt;
      motion.car.element.hidden = !visible || map.getZoom() >= 10.5;
      if (motion.bike) motion.bike.element.hidden = !moving || map.getZoom() < 10.5
        || !map.getBounds().contains([motion.vondeltuin.lng, motion.vondeltuin.lat]);
      if (moving && !motionFrame) motionFrame = window.requestAnimationFrame(animateMotion);
      if (!moving && motionFrame) { window.cancelAnimationFrame(motionFrame); motionFrame = 0; }
    }
    function setupMotion() {
      if (!mapLoaded || loading || motion || !window.BbMapMotion) return;
      const points = rows.filter((row) => Number.isFinite(row.bbMapLng))
        .map((row) => ({ lng: row.bbMapLng, lat: row.bbMapLat, city: row.dataset.city }));
      const belgium = window.BbMapRegions?.features?.find((feature) => feature.properties?.name === 'België')?.geometry;
      const route = window.BbMapMotion.carRoute(points, belgium);
      const vondeltuinRow = rows.find((row) => /vondeltuin/i.test(row.dataset.title) && Number.isFinite(row.bbMapLng));
      if (!route) return;
      const vondeltuin = vondeltuinRow && { lng: vondeltuinRow.bbMapLng, lat: vondeltuinRow.bbMapLat };
      motion = { route, vondeltuin, started: performance.now(), pausedAt: 0, pauseReasons: new Set(),
        car: addVehicle('car', section.dataset.carIcon, route.legs[0].from),
        bike: vondeltuin ? addVehicle('bike', section.dataset.bikeIcon, vondeltuin) : null };
      updateMotionActivity();
    }
    function spreadPins() {
      if (!map) return;
      const points = [...markers].map(([row, marker]) => ({
        marker, point: map.project([row.bbMapLng, row.bbMapLat]), dx: 0, dy: 0,
      }));
      for (let pass = 0; pass < 14; pass++) {
        for (let i = 0; i < points.length; i++) for (let j = i + 1; j < points.length; j++) {
          const a = points[i], b = points[j];
          const dx = a.point.x + a.dx - b.point.x - b.dx;
          const dy = a.point.y + a.dy - b.point.y - b.dy;
          const distance = Math.hypot(dx, dy);
          if (distance >= 32) continue;
          const angle = distance < .01 ? (i + j * 2) * 2.4 : Math.atan2(dy, dx);
          const push = (32 - distance) / 2;
          a.dx += Math.cos(angle) * push; a.dy += Math.sin(angle) * push;
          b.dx -= Math.cos(angle) * push; b.dy -= Math.sin(angle) * push;
        }
      }
      for (const point of points) point.marker.setOffset([point.dx, point.dy]);
    }
    function renderPins() {
      if (!map) return;
      const visible = new Set(visibleRows());
      for (const [row, marker] of markers) {
        if (!visible.has(row)) { marker.remove(); markers.delete(row); row.bbMapPin = null; }
      }
      for (const row of visible) {
        if (markers.has(row)) {
          row.bbMapPin.classList.toggle('is-selected', row === selected || row === popupRow);
          continue;
        }
        const pin = document.createElement('button');
        pin.type = 'button';
        pin.className = 'bb-map__pin';
        const icon = document.createElement('img');
        icon.src = section.dataset.treeIcon; icon.alt = '';
        pin.append(icon);
        pin.classList.toggle('is-new', row.dataset.new === 'true');
        pin.classList.toggle('is-selected', row === selected || row === popupRow);
        pin.setAttribute('aria-label', `Bekijk ${row.dataset.title} op de kaart`);
        pin.addEventListener('click', (event) => { event.stopPropagation(); showPopup(row, pin); });
        row.bbMapPin = pin;
        markers.set(row, new window.maplibregl.Marker({ element: pin, anchor: 'bottom' })
          .setLngLat([row.bbMapLng, row.bbMapLat]).addTo(map));
      }
      spreadPins();
    }
    function applySearch() {
      const query = normalise(search.value.trim());
      let matches = 0;
      for (const row of rows) {
        const location = records.get(row);
        row.hidden = !matchesLocation(query, row, location);
        if (!row.hidden) matches++;
      }
      for (const city of cities) city.hidden = !city.querySelector('[data-bb-map-location]:not([hidden])');
      const mapped = visibleRows().length;
      count.textContent = `${matches} locatie${matches === 1 ? '' : 's'} · ${mapped} op de kaart${loading ? ' · kaart laden…' : ''}`;
      empty.hidden = matches > 0;
      if (popupRow?.hidden) hidePopup();
      renderPins();
      if (query && mapped) zoomToRows(visibleRows());
    }
    function hidePopup(restoreFocus = false) {
      const focusRow = popupRow;
      popupRequest++;
      popup.hidden = true;
      popupRow = null;
      const wasDelivery = popupKind === 'delivery';
      popupKind = null;
      if (wasDelivery) {
        motion?.car.element.setAttribute('aria-expanded', 'false');
        setMotionPaused('delivery', false);
        updateMotionActivity();
      }
      $('[data-bb-map-popup-cluster]').replaceChildren();
      renderPins();
      if (restoreFocus) {
        const target = returnFocus?.isConnected ? returnFocus
          : (focusRow?.bbMapPin?.isConnected ? focusRow.bbMapPin : focusRow?.querySelector('[data-bb-map-result-link]'));
        target?.focus({ preventScroll: true });
      }
    }
    function scheduleFor(location, products) {
      const key = `${location.id}:${products.map((product) => product.variant_id).join(':')}`;
      if (!scheduleCache.has(key)) {
        const request = window.BbZapiet.pickupSchedule(section.dataset.shop, location.id, products, 8);
        scheduleCache.set(key, request);
        request.catch(() => { if (scheduleCache.get(key) === request) scheduleCache.delete(key); });
      }
      return scheduleCache.get(key);
    }
    function showPopup(row, trigger) {
      if (popupKind === 'delivery') hidePopup();
      const requestId = ++popupRequest;
      popupRow = row;
      popupKind = 'location';
      returnFocus = trigger || row.querySelector('[data-bb-map-result-link]');
      $('[data-bb-map-popup-cluster]').hidden = true;
      $('[data-bb-map-popup-open]').hidden = false;
      $('[data-bb-map-popup-delivery]').hidden = true;
      $('[data-bb-map-popup-title]').textContent = row.dataset.title;
      const location = records.get(row);
      $('[data-bb-map-popup-address]').textContent = address(location?.address_line_1, location?.postal_code, location?.city) || row.dataset.city;
      const image = $('[data-bb-map-popup-image]');
      image.hidden = !row.dataset.image;
      popup.classList.toggle('has-image', Boolean(row.dataset.image));
      if (row.dataset.image) { image.src = row.dataset.image; image.alt = row.dataset.title; }
      const moment = $('[data-bb-map-popup-moment]');
      moment.textContent = statusLabels[row.dataset.status] || (row.dataset.treeAvailable !== 'true'
        ? 'Boompjes tijdelijk niet beschikbaar.' : location ? 'Eerste ophaalmoment laden…' : 'Bekijk de locatie voor actuele informatie.');
      popup.hidden = false;
      if (section.classList.contains('bb-map--search-active')) {
        search.blur();
      }
      renderPins();
      if (Number.isFinite(row.bbMapLng)) zoomToPoint(row.bbMapLng, row.bbMapLat, 12);
      if (location && row.dataset.treeAvailable === 'true' && !statusLabels[row.dataset.status]) {
        const products = [readProduct(row.dataset.firstProduct), readProduct(row.dataset.secondProduct)].filter(Boolean);
        if (products.length) scheduleFor(location, products)
          .then((schedule) => {
            if (requestId !== popupRequest) return;
            moment.textContent = schedule.length
              ? `${window.BbZapiet.formatPickupDay(schedule[0].date, schedule[0].slots)?.full || dateLabel(schedule[0].date)}${schedule.length > 1 ? ` · ${schedule.length === 8 ? 'Meer ophaaldagen' : `+${schedule.length - 1} meer`}` : ''}`
              : 'Ophaalmomenten volgen nog.';
          }).catch(() => { if (requestId === popupRequest) moment.textContent = 'Ophaalmomenten tijdelijk niet beschikbaar.'; });
      }
    }
    function showDeliveryPopup() {
      if (!motion) return;
      if (!popup.hidden) hidePopup();
      setMotionPaused('delivery', true);
      updateMotionActivity();
      popupKind = 'delivery';
      returnFocus = motion.car.element;
      motion.car.element.setAttribute('aria-expanded', 'true');
      $('[data-bb-map-popup-cluster]').hidden = true;
      $('[data-bb-map-popup-open]').hidden = true;
      $('[data-bb-map-popup-delivery]').hidden = false;
      $('[data-bb-map-popup-title]').textContent = 'Jouw kerstboom thuisbezorgd';
      $('[data-bb-map-popup-address]').textContent = 'Kies een boom met of zonder kluit.';
      $('[data-bb-map-popup-moment]').textContent = 'Bezorgdatum kiezen in de winkelwagen';
      const image = $('[data-bb-map-popup-image]');
      image.hidden = !section.dataset.deliveryImage;
      if (section.dataset.deliveryImage) { image.src = section.dataset.deliveryImage; image.alt = 'Thuisbezorgen'; }
      popup.classList.toggle('has-image', Boolean(section.dataset.deliveryImage));
      popup.hidden = false;
      $('[data-bb-map-popup-close]').focus({ preventScroll: true });
    }
    function setHash(value, push = false) {
      const url = new URL(window.location.href);
      url.hash = value || '';
      window.history[push ? 'pushState' : 'replaceState'](null, '', url);
    }
    function closeDetail(restore = true, fromNavigation = false) {
      if (detail.hidden || detail.classList.contains('is-closing')) return;
      const returnInHistory = !fromNavigation && ownsHistory;
      const focusRow = selected;
      scheduleRequest++;
      detail.classList.add('is-closing');
      detail.inert = true;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(() => {
        detail.hidden = true;
        detail.classList.remove('is-closing');
      }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 240);
      section.classList.remove('bb-map--detail-open');
      document.body.classList.remove('bb-map-detail-open');
      $('[data-bb-map-layout]').inert = false;
      selected = null;
      if (returnInHistory) {
        window.history.back();
        window.setTimeout(() => {
          if (!detail.hidden || readHash(window.location.hash) === focusRow?.dataset.handle) setHash('');
        }, 350);
      } else if (!fromNavigation) setHash('');
      ownsHistory = false;
      renderPins();
      if (selectedRegion) zoomToRegion(selectedRegion);
      else zoomToRows(visibleRows());
      if (restore) {
        const target = returnFocus?.isConnected ? returnFocus
          : (focusRow?.bbMapPin?.isConnected ? focusRow.bbMapPin : focusRow?.querySelector('[data-bb-map-result-link]'));
        target?.focus({ preventScroll: true });
      }
    }
    function renderSchedule(row, schedule) {
      const list = $('[data-bb-map-schedule]');
      list.replaceChildren();
      const status = $('[data-bb-map-schedule-status]');
      const month = $('[data-bb-map-schedule-month]');
      month.textContent = '';
      if (!schedule.length) { status.textContent = 'Er zijn nog geen ophaalmomenten bevestigd.'; return; }
      status.textContent = '';
      const months = [...new Set(schedule.map((entry) => monthLabel(entry.date)))];
      month.textContent = months.join(' · ');
      $('[data-bb-map-detail-link]').hidden = false;
      for (const entry of schedule) {
        const item = document.createElement('li');
        const day = document.createElement('span');
        day.className = 'bb-map__schedule-day';
        const formatted = window.BbZapiet.formatPickupDay(entry.date, entry.slots);
        day.textContent = formatted?.day || dateLabel(entry.date);
        const time = document.createElement('span');
        time.className = 'bb-map__schedule-time';
        time.textContent = formatted?.time || '';
        item.append(day, time);
        list.append(item);
      }
    }
    async function loadSchedule(row) {
      const location = records.get(row);
      const products = [readProduct(row.dataset.firstProduct), readProduct(row.dataset.secondProduct)].filter(Boolean);
      const requestId = ++scheduleRequest;
      const status = $('[data-bb-map-schedule-status]');
      const skeleton = $('[data-bb-map-skeleton]');
      $('[data-bb-map-detail-link]').hidden = true;
      $('[data-bb-map-schedule]').replaceChildren();
      $('[data-bb-map-schedule-month]').textContent = '';
      if (!location || !products.length || row.dataset.treeAvailable !== 'true' || ['pending', 'confirmed', 'sold_out', 'paused', 'former'].includes(row.dataset.status)) {
        status.textContent = statusLabels[row.dataset.status] || (row.dataset.treeAvailable !== 'true'
          ? 'Boompjes zijn hier tijdelijk niet beschikbaar.' : 'Ophaalmomenten zijn nog niet beschikbaar.');
        skeleton.hidden = true;
        return;
      }
      status.textContent = 'Ophaalmomenten laden…';
      skeleton.hidden = false;
      try {
        const schedule = await scheduleFor(location, products);
        if (requestId === scheduleRequest) renderSchedule(row, schedule);
      } catch (_error) {
        if (requestId === scheduleRequest) status.textContent = 'Ophaalmomenten zijn tijdelijk niet beschikbaar. Bekijk de locatie voor de actuele keuze.';
      } finally { if (requestId === scheduleRequest) skeleton.hidden = true; }
    }
    function openDetail(row, trigger, fromNavigation = false) {
      const wasOpen = !detail.hidden;
      clearTimeout(closeTimer);
      detail.classList.remove('is-closing');
      detail.inert = false;
      returnFocus = trigger || returnFocus || row.querySelector('[data-bb-map-result-link]');
      selected = row;
      hidePopup();
      $('[data-bb-map-detail-title]').textContent = row.dataset.title;
      const status = [row.dataset.new === 'true' ? 'Nieuw' : '', statusLabels[row.dataset.status] || ''].filter(Boolean).join(' · ');
      $('[data-bb-map-detail-status]').textContent = status;
      $('[data-bb-map-detail-status]').hidden = !status;
      const location = records.get(row);
      $('[data-bb-map-detail-address]').textContent = location
        ? address(location.address_line_1, location.address_line_2, location.postal_code, location.city)
        : row.dataset.city || '';
      $('[data-bb-map-detail-summary]').textContent = row.dataset.summary || '';
      $('[data-bb-map-detail-summary]').hidden = !row.dataset.summary;
      const link = $('[data-bb-map-detail-link]');
      link.href = row.dataset.url;
      link.textContent = ['pending', 'confirmed', 'sold_out', 'paused', 'former'].includes(row.dataset.status)
        ? 'Bekijk locatie' : 'Bestel & haal op';
      const image = $('[data-bb-map-detail-image]');
      image.hidden = !row.dataset.image;
      if (row.dataset.image) { image.src = row.dataset.image; image.alt = row.dataset.title; }
      const products = $('[data-bb-map-products]');
      products.replaceChildren(row.querySelector('[data-bb-map-product-cards]').content.cloneNode(true));
      const detailBody = detail.querySelector('.bb-map__detail-body');
      detailBody.classList.remove('is-refreshing');
      detail.hidden = false;
      if (window.matchMedia('(max-width: 749px) and (prefers-reduced-motion: no-preference)').matches) {
        void detailBody.offsetWidth;
        detailBody.classList.add('is-refreshing');
      }
      section.classList.add('bb-map--detail-open');
      document.body.classList.add('bb-map-detail-open');
      $('[data-bb-map-layout]').inert = true;
      if (!fromNavigation) {
        ownsHistory = ownsHistory || !wasOpen;
        setHash(row.dataset.handle, !wasOpen);
      }
      if (Number.isFinite(row.bbMapLng)) zoomToPoint(row.bbMapLng, row.bbMapLat, 10);
      loadSchedule(row);
      close.focus({ preventScroll: true });
    }
    async function resolve(row, usage) {
      const first = readProduct(row.dataset.firstProduct);
      const second = readProduct(row.dataset.secondProduct);
      if (!first || (!row.dataset.zapietId && usage.get(first.product_id) > 1)) return;
      try {
        let matches = await window.BbZapiet.locationsFor(section.dataset.shop, first);
        if (second) {
          const otherIds = new Set((await window.BbZapiet.locationsFor(section.dataset.shop, second)).map((item) => String(item.id)));
          matches = matches.filter((item) => otherIds.has(String(item.id)));
        }
        const location = window.BbZapiet.resolve(matches, row.dataset.zapietId, row.dataset.title, usage.get(first.product_id) > 1);
        if (!location) return;
        records.set(row, location);
        row.querySelector('[data-bb-map-address]').textContent = [location.city, location.postal_code].filter(Boolean).join(' · ') || 'Bekijk ophaallocatie';
        const latitude = Number(location.latitude), longitude = Number(location.longitude);
        if (Number.isFinite(latitude) && Number.isFinite(longitude) && latitude > 49 && latitude < 54 && longitude > 2 && longitude < 8) {
          row.bbMapLng = longitude; row.bbMapLat = latitude;
        }
        applySearch();
      } catch (_error) { /* Collection links remain available. */ }
    }

    rows.forEach((row) => {
      row.addEventListener('mouseenter', () => row.bbMapPin?.classList.add('is-highlighted'));
      row.addEventListener('mouseleave', () => row.bbMapPin?.classList.remove('is-highlighted'));
      row.addEventListener('focusin', () => row.bbMapPin?.classList.add('is-highlighted'));
      row.addEventListener('focusout', () => row.bbMapPin?.classList.remove('is-highlighted'));
    });
    search.addEventListener('input', applySearch);
    $('[data-bb-map-popup-close]').addEventListener('click', () => {
      hidePopup(true);
      if (selectedRegion) zoomToRegion(selectedRegion);
      else zoomToRows(visibleRows());
    });
    $('[data-bb-map-popup-open]').addEventListener('click', () => { if (popupRow) openDetail(popupRow, returnFocus); });
    let popupTouchY = null;
    popup.addEventListener('touchstart', (event) => { popupTouchY = event.touches[0]?.clientY ?? null; }, { passive: true });
    popup.addEventListener('touchend', (event) => {
      if (popupTouchY !== null && (event.changedTouches[0]?.clientY ?? popupTouchY) - popupTouchY > 65) hidePopup();
      popupTouchY = null;
    }, { passive: true });
    close.addEventListener('click', () => closeDetail());
    section.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { if (!detail.hidden) closeDetail(); else if (!popup.hidden) hidePopup(true); }
      if (event.key === 'Tab' && !detail.hidden) {
        const focusable = [...detail.querySelectorAll('button, a[href]')].filter((node) => node.offsetParent !== null);
        if (!focusable.length) return;
        if (event.shiftKey && document.activeElement === focusable[0]) { event.preventDefault(); focusable.at(-1).focus(); }
        if (!event.shiftKey && document.activeElement === focusable.at(-1)) { event.preventDefault(); focusable[0].focus(); }
      }
    });
    $('[data-bb-map-zoom-in]').addEventListener('click', () => map?.zoomIn());
    $('[data-bb-map-zoom-out]').addEventListener('click', () => map?.zoomOut());
    $('[data-bb-map-reset]').addEventListener('click', showWholeMap);
    $('[data-bb-map-nearby]').addEventListener('click', () => {
      if (!navigator.geolocation) { message.textContent = 'Je browser kan je locatie niet bepalen. Zoek op plaatsnaam.'; message.hidden = false; return; }
      message.textContent = 'Je locatie bepalen…'; message.hidden = false;
      navigator.geolocation.getCurrentPosition(({ coords }) => {
        const candidates = visibleRows();
        if (!candidates.length) { message.textContent = 'Er zijn nog geen kaartpunten beschikbaar. Zoek op plaatsnaam.'; return; }
        const distance = (row) => Math.hypot((row.bbMapLng - coords.longitude) * Math.cos(coords.latitude * Math.PI / 180), row.bbMapLat - coords.latitude);
        const nearest = candidates.sort((a, b) => distance(a) - distance(b))[0];
        showPopup(nearest, nearest.querySelector('[data-bb-map-result-link]'));
        message.textContent = `Dichtstbijzijnde ophaallocatie: ${nearest.dataset.title}.`;
      }, () => { message.textContent = 'Locatie niet beschikbaar. Zoek op plaatsnaam.'; }, { timeout: 8000, maximumAge: 0 });
    });
    function syncFromHash() {
      const handle = readHash(window.location.hash);
      if (!handle && !detail.hidden) closeDetail(true, true);
      else if (handle) {
        const row = rows.find((item) => item.dataset.handle === handle);
        if (row && selected !== row) openDetail(row, row.querySelector('[data-bb-map-result-link]'), true);
      }
    }
    window.addEventListener('popstate', syncFromHash);
    window.addEventListener('hashchange', syncFromHash);
    if (window.maplibregl) {
      map = new window.maplibregl.Map({
        container: tiles,
        style: 'https://tiles.openfreemap.org/styles/positron',
        center: [5.0, 51.7], zoom: 6,
        attributionControl: { compact: true },
        scrollZoom: true,
        dragRotate: false,
        touchPitch: false,
        renderWorldCopies: false,
        minZoom: 6,
        maxZoom: 16,
        maxBounds: [[2.45, 49.45], [7.65, 53.65]],
      });
      map.touchZoomRotate.disableRotation();
      map.on('zoomend', updateMotionActivity);
      if (window.ResizeObserver) new ResizeObserver(() => map?.resize()).observe(viewport);
      map.on('moveend', spreadPins);
      map.on('error', () => {
        if (!map.loaded()) {
          plane.hidden = false;
          message.textContent = 'Kaarttegels tijdelijk niet beschikbaar. Kies een locatie in de lijst.';
          message.hidden = false;
        }
      });
      map.once('load', () => {
        mapLoaded = true;
        plane.hidden = true;
        const attribution = tiles.querySelector('.maplibregl-ctrl-attrib');
        if (attribution) {
          attribution.open = false;
          attribution.classList.remove('maplibregl-compact-show');
        }
        for (const [layer, property, color] of [
          ['background', 'background-color', '#fffdf8'],
          ['park', 'fill-color', '#f0f5ef'],
          ['landcover_wood', 'fill-color', '#e7f0e8'],
          ['landuse_residential', 'fill-color', '#fbfaf5'],
          ['water', 'fill-color', '#dcebf8'],
          ['highway_major_subtle', 'line-color', '#e3e1dd'],
          ['highway_motorway_subtle', 'line-color', '#dededb'],
        ]) {
          if (map.getLayer(layer)) map.setPaintProperty(layer, property, color);
        }
        if (map.getLayer('highway_major_subtle')) map.setPaintProperty('highway_major_subtle', 'line-opacity', [
          'interpolate', ['linear'], ['zoom'], 6, 0.06, 9, 0.45, 12, 1,
        ]);
        if (map.getLayer('highway_motorway_subtle')) map.setPaintProperty('highway_motorway_subtle', 'line-opacity', [
          'interpolate', ['linear'], ['zoom'], 6, 0.2, 9, 0.65, 12, 1,
        ]);
        for (const layer of ['highway_motorway_casing', 'highway_motorway_bridge_casing']) {
          if (map.getLayer(layer)) map.setPaintProperty(layer, 'line-opacity', [
            'interpolate', ['linear'], ['zoom'], 6, 0.08, 9, 0.35, 12, 0.75, 14, 1,
          ]);
        }
        for (const layer of ['highway_motorway_inner', 'highway_motorway_bridge_inner']) {
          if (map.getLayer(layer)) map.setPaintProperty(layer, 'line-opacity', [
            'interpolate', ['linear'], ['zoom'], 6, 0.15, 9, 0.45, 12, 1,
          ]);
        }
        if (map.getLayer('highway_minor')) map.setPaintProperty('highway_minor', 'line-opacity', [
          'interpolate', ['linear'], ['zoom'], 8, 0, 10, 0.2, 13, 0.65, 16, 0.9,
        ]);
        if (map.getLayer('boundary_3')) map.setPaintProperty('boundary_3', 'line-opacity', [
          'interpolate', ['linear'], ['zoom'], 8, 0.08, 11, 0.35, 14, 0.7,
        ]);
        if (map.getLayer('label_village')) map.setPaintProperty('label_village', 'text-opacity', [
          'interpolate', ['linear'], ['zoom'], 9, 0, 11, 0.5, 13, 1,
        ]);
        if (map.getLayer('label_town')) map.setPaintProperty('label_town', 'text-opacity', [
          'interpolate', ['linear'], ['zoom'], 6, 0, 8, 1,
        ]);
        if (map.getLayer('label_other')) map.setLayoutProperty('label_other', 'visibility', 'none');
        for (const layer of ['water_name_point_label', 'water_name_line_label', 'highway_path', 'label_country_1', 'label_country_2', 'label_country_3']) {
          if (map.getLayer(layer)) map.setLayoutProperty(layer, 'visibility', 'none');
        }
        if (window.BbMapOutsideMask) {
          map.addSource('bb-outside-mask', { type: 'geojson', data: window.BbMapOutsideMask });
          map.addLayer({ id: 'bb-outside-mask', type: 'fill', source: 'bb-outside-mask', paint: { 'fill-color': '#e7f1ea', 'fill-opacity': 1 } });
        }
        if (window.BbMapRegions) {
          map.addSource('bb-regions', { type: 'geojson', data: window.BbMapRegions });
          map.addLayer({ id: 'bb-regions-fill', type: 'fill', source: 'bb-regions', paint: { 'fill-color': '#625fbe', 'fill-opacity': 0.001 } });
          map.on('click', 'bb-regions-fill', (event) => {
            const name = event.features?.[0]?.properties?.name;
            if (name && regions[name]) zoomToRegion(name);
          });
          map.on('mouseenter', 'bb-regions-fill', () => { map.getCanvas().style.cursor = 'pointer'; });
          map.on('mouseleave', 'bb-regions-fill', () => { map.getCanvas().style.cursor = ''; });
        }
        zoomToRows(visibleRows());
        setupMotion();
      });
    } else {
      plane.hidden = false;
      message.textContent = 'De kaart is tijdelijk niet beschikbaar. Kies een locatie in de lijst.';
      message.hidden = false;
    }
    if (!section.dataset.shop || !rows.length) {
      count.textContent = rows.length ? 'Locaties laden…' : 'Er zijn nog geen ophaallocaties geselecteerd.';
      return;
    }
    applySearch();
    const usage = new Map();
    rows.forEach((row) => {
      const product = readProduct(row.dataset.firstProduct);
      if (product) usage.set(product.product_id, (usage.get(product.product_id) || 0) + 1);
    });
    runPool(rows, 4, (row) => resolve(row, usage)).finally(() => {
      loading = false;
      applySearch();
      setupMotion();
      if (!readHash(window.location.hash)) zoomToRows(visibleRows());
      const handle = readHash(window.location.hash);
      const row = rows.find((item) => item.dataset.handle === handle);
      if (row) openDetail(row, row.querySelector('[data-bb-map-result-link]'), true);
    });
  }

  document.querySelectorAll('[data-bb-location-map]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-bb-location-map]').forEach(init);
  });
})();
